import { render, staticRenderFns } from "./SupportShow.vue?vue&type=template&id=1bf5acf5&scoped=true&"
import script from "./SupportShow.vue?vue&type=script&lang=js&"
export * from "./SupportShow.vue?vue&type=script&lang=js&"
import style0 from "./SupportShow.vue?vue&type=style&index=0&id=1bf5acf5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf5acf5",
  null
  
)

export default component.exports